import { View } from "binder"
import { ReplacementReasonManipulationViewModel, ReplacementReason } from "./replacementReasonManipulation-viewModel"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";

export class ReplacementReasonManipulationView extends View<ReplacementReasonManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-A4E44C63-F0F3-4286-8FA0-04451C3492A0"
    }
    loadHtml(): string {
        let element = require('./replacementReasonManipulation.html').default;
        let style = require('./replacementReasonManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set replacementReasons(v: ReplacementReason) { this._replacementReasons = v; } public get replacementReasons(): ReplacementReason { return this._replacementReasons; } private _replacementReasons: ReplacementReason;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;

    addNew() {
        this.dataContext.addNew();
    }
}
